module.exports = __webpack_public_path__ + "static/media/mod-viralvault.65718857.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/mod-viralvault.jpg
// module id = 345
// module chunks = 0